export { default, getServerSideProps } from './Welcome';
